import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import EventCard from "@/components/EventCard";
import { useLang } from "@/context/LanguageContext";
import { CATEGORY_META } from "@/lib/categories";
import { CATEGORY_LABELS } from "@/i18n/translations";
import { ArrowLeft } from "lucide-react";

export default function CategoryPage() {
  const { cat } = useParams();
  const { t, tCategory } = useLang();
  const { data: events = [], isLoading } = useQuery({ queryKey: ["catEvents", cat], queryFn: async () => (await api.get("/events", { params: { category: cat, limit: 200 } })).data });
  const meta = CATEGORY_META[cat] || {};
  const Icon = meta.icon;

  return (
    <>
      <Seo title={tCategory(cat)} description={`${tCategory(cat)} — swiss-pagan.ch`} canonicalPath={`/category/${cat}`} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
        <Link to="/categories" className="inline-flex items-center gap-1.5 text-stone-400 hover:text-amber-400 text-sm mb-6"><ArrowLeft className="w-4 h-4" /> {t("nav_categories")}</Link>
        <div className="flex items-center gap-4 mb-10 border-b border-amber-900/30 pb-5">
          {Icon && <span className="w-14 h-14 rounded-xl bg-amber-950/40 border border-amber-800/40 flex items-center justify-center shrink-0"><Icon className="w-7 h-7" style={{ color: meta.color }} /></span>}
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-amber-500/90 mb-1">{t("filter_category")}</div>
            <h1 className="font-serif text-3xl sm:text-5xl uppercase tracking-tight text-amber-100">{tCategory(cat)}</h1>
          </div>
        </div>
        {isLoading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[...Array(3)].map((_, i) => <div key={i} className="h-72 bg-[#121418] border border-[#272A34] rounded-lg animate-pulse" />)}</div>
        ) : events.length === 0 ? (
          <div className="text-center py-24 text-stone-400 border border-dashed border-[#272A34] rounded-lg">{t("no_results")}</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{events.map((e, i) => <EventCard key={e.slug} event={e} index={i} />)}</div>
        )}
      </div>
    </>
  );
}
